//@flow
import { type stateType } from "./reducer";

export const getDialog = (state: stateType) => state.dialog;
